module.exports = __webpack_public_path__ + "img/8.3ce1790a.png";